import EAInputBloc from '../../../../../../../../components/common/EAInputBloc';
import i18next from 'i18next';
import { Controller, useFormContext } from 'react-hook-form';
import EADatePicker from '../../../../../../../../components/common/EADatePicker';
import React from 'react';

const EqualValue = ({ fieldName, showLabel, readOnly = false }) => {
  const formMethods = useFormContext();

  return (
    <EAInputBloc
      label={`${
        showLabel ? i18next.t('calculator.dialog.create.label.values') : ''
      }`}
      customLabelStyle={{ fontSize: '14px' }}
    >
      <Controller
        control={formMethods.control}
        name={`${fieldName}.${0}`}
        rules={{
          required: i18next.t(`infos.required`),
          validate: (value) => {
            if (!value) {
              return i18next.t(`infos.required`);
            }
            // Add more custom validation logic if needed
            return true;
          },
        }}
        render={({ field }) => (
          <EADatePicker
            {...field}
            name={field.name}
            formMethods={formMethods}
            disableHighlightToday
            ref={null}
            isRequired
            isDisabled={readOnly}
            triggerOnContinue
          />
        )}
      />
    </EAInputBloc>
  );
};

export default EqualValue;
